import React from 'react';
import NavBar from '../components/shared/Navbar';
import Title from '../components/shared/Title';
import styled from 'styled-components';
import Icon from '../components/shared/Icon';
import Text from '../components/shared/Text';
import { palette, breakpoints } from '../constants/styles';
import Footer from '../components/landing/Footer';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;

  ${breakpoints.mobileLandscape} {
    padding: 20px 100px 80px 100px;
  }

  ${breakpoints.tabletLandscape} {
    padding: 20px 250px 80px 250px;
  }

  ${breakpoints.desktop} {
    padding: 20px 33% 80px 33%;
  }
`;

const ClingWrapper = styled.div`
  margin: 50px 0px;
`;

export default function Congrats(props) {
  const phone = props.match.params.phone ? props.match.params.phone : '-número inexistente-';
  const plan_code = props.match.params.planLink ? props.match.params.planLink : '_';
  const referral = props.match.params.referralId ? props.match.params.referralId : '_';

  return (
    <>
      <NavBar />
      <Content>
        <ClingWrapper>
          <Icon icon="whatsapp_friendly" color={palette.secondaryColor} size={150} />
        </ClingWrapper>
        <Title level={3} light>
          Revisa tu teléfono, te hemos enviado un mensaje de WhatsApp al número <b>{phone}</b>.
        </Title>
        <Text type="body2" style={{ marginTop: '25px' }}>
          Contesta a nuestro mensaje, de lo contrario no podrás agendar tu llamada de diagnóstico.
        </Text>

        <Text type="body2" style={{ marginTop: '25px' }}>
          ¿El número que nos compartiste es incorrecto?{' '}
          <Link to={`/retiro/contacto/${phone}/${referral}/${plan_code}`}>
            Vuelve a llenar el formulario aquí.
          </Link>
        </Text>
        <Text type="body2" style={{ marginTop: '25px' }}>
          Si no tienes WhatsApp o no has recibido nuestro mensaje después de 5 minutos, llama en
          horario laboral al <b>81-4170-0809</b> para agendar tu diagnóstico.
        </Text>
        <Text type="body2" style={{ marginTop: '25px' }}>
          ¡Felicidades por tomar el primer paso para lograr tu pensión ideal!
        </Text>
        <Title level={5} align="left" style={{ alignSelf: 'flex-start', marginTop: '25px' }}>
          - Equipo Finauta
        </Title>
      </Content>
      <Footer />
    </>
  );
}
